/* @flow */
import { reducer, initialState } from 'payments/reducers/ConnectedBankAccounts';
import { ReduceStore } from 'flux/utils';
import { dispatcher } from 'lib/Dispatcher';

class ConnectedBankAccountStore extends ReduceStore {
  getInitialState() {
    return initialState;
  }

  getConnectedBankAccounts() {
    return this.getState().connectedBankAccounts;
  }

  isAdmin() {
    // An admin is defined by someone for whom at least one of the connected bank accounts
    // can be managed by the current user.
    return this.getState().connectedBankAccounts.some(account => account.getCanManage());
  }

  reduce(state, action) {
    return reducer(state, action);
  }
}

export default new ConnectedBankAccountStore(dispatcher);



// WEBPACK FOOTER //
// ./src/payments/stores/ConnectedBankAccountStore.js